export default __webpack_public_path__ + "static/media/goshen74.75b25f46.jpg";